// Where the screw connector's admin entities are served.
export const SCREW_CONNECTOR_ADMIN_URL = "/admin/modules/screw_connector";
